import { render, staticRenderFns } from "./edit-working-policy-form.vue?vue&type=template&id=03b8bacf&scoped=true&"
import script from "./edit-working-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-working-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-working-policy-form.vue?vue&type=style&index=0&id=03b8bacf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8bacf",
  null
  
)

export default component.exports